module.exports = __webpack_public_path__ + "static/card-metrics-cfbbdc6977954785f6e28b85054bd811.png";